import { UseChatHelpers } from '@ai-sdk/react';
import { useParams } from 'react-router-dom';

import { SvbrgAgentId } from '@/generated/gql/graphql';
import { Metadata, UIChatMessage } from '@/legacy/components/Chat/chat.types';
import { SubmitArgs } from '~/components/Chat/ChatUserMessage/ChatUserMessage.types';

import { useAgentSubmitHandler } from './useAgentSubmitHandler';
import { useChat } from './useChat';
import { useConversationStarter } from './useConversationStarter';

interface UseIntakeChatResult {
  isLoading: boolean;
  chat?: UseChatHelpers<UIChatMessage>;
  agentId?: SvbrgAgentId;
  status: UseChatHelpers<UIChatMessage>['status'] | undefined;
  messages: UseChatHelpers<UIChatMessage>['messages'];
  error: UseChatHelpers<UIChatMessage>['error'] | undefined;
  handleSubmit: (args: SubmitArgs, metadata?: Metadata) => Promise<void>;
  sendMessage: UseChatHelpers<UIChatMessage>['sendMessage'] | undefined;
}

export const useIntakeChat = (): UseIntakeChatResult => {
  const params = useParams<'id'>();

  const { isLoading, chat, agentId } = useChat(params.id ?? '');
  const { status, messages = [], sendMessage, error } = chat ?? {};

  // use a conversation starter if needed (only when chat is ready)
  useConversationStarter(isLoading, chat);

  // get the appropriate submit handler for the current agent
  const handleSubmit = useAgentSubmitHandler(agentId, sendMessage);

  return {
    isLoading: isLoading || !chat,
    chat,
    agentId,
    status,
    messages,
    error,
    handleSubmit,
    sendMessage,
  };
};
